<template>
  <transition name="import-confirm-dialog" appear>
    <div
      v-if="value"
      class="import-confirm-dialog__overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="import-confirm-dialog-title"
      aria-describedby="import-confirm-dialog-body"
      data-testid="import-confirm-dialog"
      @mousedown.self="onKeep"
      @keydown.esc="onKeep"
    >
      <div class="import-confirm-dialog__card">
        <h2 id="import-confirm-dialog-title" class="import-confirm-dialog__title">{{ title }}</h2>
        <p id="import-confirm-dialog-body" class="import-confirm-dialog__body">{{ body }}</p>
        <div class="import-confirm-dialog__footer">
          <StandardButton
            type="magenta"
            variant="secondary"
            size="normal"
            :label="keepLabel"
            :disabled="loading"
            data-testid="import-confirm-keep"
            @click="onKeep"
          />
          <StandardButton
            type="red"
            variant="primary"
            size="normal"
            :label="confirmLabel"
            :disabled="loading"
            :loaderLeft="loading"
            data-testid="import-confirm-confirm"
            @click="onConfirm"
          />
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import StandardButton from "@components/StandardButton/StandardButton.vue";

const props = defineProps({
  value: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    required: true,
  },
  body: {
    type: String,
    required: true,
  },
  keepLabel: {
    type: String,
    default: "Keep processing",
  },
  confirmLabel: {
    type: String,
    default: "Cancel import",
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["input", "confirm"]);

function onKeep() {
  if (props.loading) return;
  emit("input", false);
}

function onConfirm() {
  if (props.loading) return;
  emit("confirm");
}
</script>

<style scoped>
.import-confirm-dialog__overlay {
  position: fixed;
  inset: 0;
  z-index: 11000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(16, 24, 40, 0.5);
}

.import-confirm-dialog__card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  max-width: 480px;
  padding: 24px;
  background: #ffffff;
  border: 1px solid #d0d5dd;
  border-radius: 12px;
  box-shadow: 0 8px 24px -4px rgba(15, 23, 41, 0.15);
  box-sizing: border-box;
}

.import-confirm-dialog__title {
  margin: 0;
  font-family: Inter, sans-serif;
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
  color: #101828;
}

.import-confirm-dialog__body {
  margin: 0;
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #475467;
}

.import-confirm-dialog__footer {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding-top: 8px;
}

.import-confirm-dialog-enter-active,
.import-confirm-dialog-leave-active {
  transition: opacity 0.15s ease;
}

.import-confirm-dialog-enter,
.import-confirm-dialog-leave-to {
  opacity: 0;
}
</style>
